import { Task, UpcomingPeriod } from '@griply/types';
import { buildPeriodRestoreSchedules, getPeriodTarget } from '@griply/utils';
import { useUpdateTask } from 'features/tasks';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';

export type UsePeriodTargetOptions = {
  task: Task;
  period: UpcomingPeriod;
};

export const usePeriodTarget = ({ task, period }: UsePeriodTargetOptions) => {
  const today = useToday();
  const { submit: updateTask } = useUpdateTask();

  const target = useMemo(
    () => getPeriodTarget(task, period, { today }),
    [task, period, today],
  );

  const handleRestore = () => {
    if (!task.schedules?.length) {
      return;
    }

    const updatedSchedules = buildPeriodRestoreSchedules(
      task.schedules,
      period,
    );
    if (!updatedSchedules) {
      return;
    }

    updateTask({ id: task.id, schedules: updatedSchedules });
  };

  return {
    ...target,
    handleRestore,
  };
};
